import { InspectionTypeOverrides } from 'types'

const g1n6Override: InspectionTypeOverrides = {
  feature: {
    labelVisible: false,
  },
  annotationForm: {
    showLabelInput: false,
    showDamageTypeSelector: true,
    damageLabel: 'Damage Category',
    showTopSeverityRow: false,
    severityBelowDamage: true,
    showG1N6Dimensions: true,
    showG1N6Location: true,
    showTags: false,
    showScreenshots: false,
    showNotes: true,
  },
}

export default g1n6Override
